/* eslint @typescript-eslint/naming-convention: 0 */
import type { MapSourcePage } from '@/wabunka-src/common/utils/googleAnalytics/common/mapSearch';
import { sendWabunkaGAEvent } from '@/wabunka-src/common/utils/googleAnalytics/googleAnalytics';

export interface MapPreviewCtaClickParams {
  source_page: MapSourcePage;
  /** 体験 slug（purchase の item_id と突合） */
  experience_id: string;
}

/**
 * 発火タイミング：ピン選択時のプレビューカードから体験詳細へ遷移した際。
 * マップが生んだ回遊＝価値（遷移）の主指標。ダッシュボードのブロック①④⑤で使用（JCAT-4824）。
 */
export const sendGAWabunkaMapPreviewCtaClickEvent = (sourcePage: MapSourcePage, experienceId: string) => {
  sendWabunkaGAEvent('map_preview_cta_click', { source_page: sourcePage, experience_id: experienceId });
};
